<template>
  <base-container ref="container">
    <el-row style="height: 100%">
      <el-col style="height: 100%" :span="4">
        <artisan-group style="height: 100%; overflow-y: auto">
          <div slot="header">
            <span>规则模板</span>
          </div>
          <el-tree
            :data="rules"
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            :expand-on-click-node="false"
            :props="defaultProps"
            @current-change="currentChange"
          >
            <div
              :class="data.id == ruleId ? 'color-primary' : ''"
              class="custom-tree-node"
              slot-scope="{ node, data }"
            >
              <span v-text="node.label"></span>
              <span style="float: right">
                <template v-if="data.id">
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-delete"
                    @click="del(data)"
                  ></el-button>
                </template>
                <el-button
                  v-else
                  type="text"
                  size="mini"
                  icon="el-icon-plus"
                  @click="add(data)"
                ></el-button>
              </span>
            </div>
          </el-tree>
        </artisan-group>
      </el-col>
      <el-col style="height: 100%" :span="20">
        <artisan-group style="height: 100%" title="规则表达式">
          <RuleGroup
            style="height: 100%"
            :ruleId="ruleId"
            :key="ruleId"
          ></RuleGroup>
        </artisan-group>
      </el-col>
    </el-row>
  </base-container>
</template>

<script>
import { ruleList, removeRule, saveRules } from "@/api/jc/rule";
import RuleGroup from "./assist/RuleGroup";
export default {
  components: { RuleGroup },
  props: {
    queryRuleId: [String, Number],
  },
  data() {
    return {
      isLoading: false,
      rules: [],
      ruleId: this.queryRuleId || "",
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  watch: {
    queryRuleId() {
      this.ruleId = this.queryRuleId || "";
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    currentChange(data) {
      this.ruleId = data.id;
    },
    loadData() {
      ruleList().then((res) => {
        let data = res.data.data;
        let root = { id: "", name: "所有", children: data };
        this.rules = [root];
        if (!this.ruleId && data.length) {
          this.ruleId = data[0].id;
        }
      });
    },
    add() {
      this.$refs.container.prompt({ msg: "请输入规则模板名称" }).then((val) => {
        saveRules({ name: val }).then((res) => {
          this.loadData();
          this.$emit("updateRule");
        });
      });
    },
    del(data) {
      this.$refs.container.confirm({ msg: "确认删除？" }).then(() => {
        removeRule(data.id).then(() => {
          this.loadData();
          this.$emit("updateRule");
          this.$message({
            type: "success",
            message: "删除成功！",
          });
        });
      });
    },
  },
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
